var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-exam-arrange-makeup mb24" },
    [
      _c(
        "yxt-row",
        { staticClass: "bg-white" },
        [
          _c(
            "yxt-col",
            [
              _c(
                "yxt-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "is-required",
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_exampaper"),
                        prop: "examName",
                      },
                    },
                    [
                      _c("yxt-select", {
                        staticClass: "w-p-100",
                        attrs: {
                          disabled: _vm.status !== 0,
                          placeholder: _vm.$t("pc_biz_ote_lbl_pleaseselect"),
                          "icon-name": "more",
                          "hidden-option": "",
                          "collapse-tags": "",
                          "value-key": "id",
                          "prop-label": "name",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.showSelectExam.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.selectExamDrawerData.exam,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectExamDrawerData, "exam", $$v)
                          },
                          expression: "selectExamDrawerData.exam",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "is-required",
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_makeupexamname"),
                        prop: "name",
                      },
                    },
                    [
                      _c("yxt-input", {
                        staticClass: "w-p-100",
                        attrs: {
                          placeholder: _vm.$t("pc_biz_ote_tip_examnametip"),
                          "show-word-limit": "",
                          maxlength: 1000,
                        },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "is-required",
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_passscore"),
                        prop: "passScore",
                      },
                    },
                    [
                      _c("div", { staticClass: "color-gray-9 mb12 lh22 mt9" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_ote_lbl_currentexamscore", [
                              _vm.ruleForm.examId
                                ? _vm.ruleForm.totalScore
                                : "-",
                            ])
                          )
                        ),
                      ]),
                      _c(
                        "yxt-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.passScoreType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "passScoreType", $$v)
                            },
                            expression: "ruleForm.passScoreType",
                          },
                        },
                        [
                          _c(
                            "yxt-radio",
                            { attrs: { label: 1 } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_ote_lbl_passscorebynum"
                                    ) /**固定分数 */
                                  ) +
                                  "\n              "
                              ),
                              _c("yxt-input-number", {
                                staticClass: "ml12",
                                attrs: {
                                  precision: 2,
                                  step: 1,
                                  max: _vm.ruleForm.totalScore || undefined,
                                  min: 0,
                                  formatter: function (value) {
                                    return "" + (value || 0)
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.passScore,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "passScore", $$v)
                                  },
                                  expression: "ruleForm.passScore",
                                },
                              }),
                              _c("span", { staticClass: "ml8" }, [
                                _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_score"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "yxt-radio",
                            { attrs: { label: 2 } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_ote_lbl_passscorebypercent"
                                    ) /**总分比例 */
                                  ) +
                                  "\n              "
                              ),
                              _c("yxt-input-number", {
                                staticClass: "ml12",
                                attrs: {
                                  precision: 1,
                                  step: 1,
                                  max: 100,
                                  min: 0,
                                  formatter: function (value) {
                                    return "" + (value || 0)
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.passScorePercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "passScorePercent",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.passScorePercent",
                                },
                              }),
                              _c("span", { staticClass: "ml8" }, [_vm._v("%")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.typeSetting
                    ? _c(
                        "yxt-form-item",
                        {
                          staticClass: "is-required",
                          attrs: {
                            label: _vm.$t("pc_biz_ote_lbl_makeuptype"),
                            prop: "assignUserCtrlList",
                          },
                        },
                        [
                          _c(
                            "yxt-checkbox-group",
                            {
                              attrs: { direction: "row" },
                              model: {
                                value: _vm.ruleForm.assignUserCtrlList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "assignUserCtrlList",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.assignUserCtrlList",
                              },
                            },
                            [
                              _c(
                                "yxt-checkbox",
                                {
                                  attrs: {
                                    label: 2,
                                    disabled: _vm.status !== 0 ? "lock" : false,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("pc_biz_ote_lbl_notakeleanerauto")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "yxt-checkbox",
                                {
                                  attrs: {
                                    label: 4,
                                    disabled: _vm.status !== 0 ? "lock" : false,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("pc_biz_ote_lbl_nopassleanerauto")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "yxt-checkbox",
                                {
                                  attrs: {
                                    label: 1,
                                    disabled: _vm.status !== 0 ? "lock" : false,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("pc_biz_ote_lbl_makeuptypeset")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.ruleForm.assignUserCtrlList.includes(1)
                            ? _c("users-container", {
                                attrs: {
                                  users: _vm.userlist,
                                  readonly: true,
                                  placeholder: _vm.$t(
                                    "pc_biz_ote_btn_addmakeupexaminees"
                                  ),
                                },
                                on: {
                                  "update:users": function ($event) {
                                    _vm.userlist = $event
                                  },
                                  click: _vm.toViewPrescribedUser,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "is-required",
                      attrs: { label: _vm.$t("pc_biz_ote_lbl_examlimit") },
                    },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: { disabled: "lock" },
                          model: {
                            value: _vm.isEntryTimeCtrl,
                            callback: function ($$v) {
                              _vm.isEntryTimeCtrl = $$v
                            },
                            expression: "isEntryTimeCtrl",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("pc_biz_ote_lbl_entertimelimit"))
                          ),
                        ]
                      ),
                      _c(
                        "yxt-form-item",
                        {
                          staticClass:
                            "is-required yxtbiz-exam-arrange-makeup__entrytime",
                          attrs: {
                            prop: "entryTime",
                            label: _vm.$t("pc_biz_ote_lbl_entertime"),
                          },
                        },
                        [
                          _c("yxt-date-picker", {
                            staticClass: "w-200",
                            attrs: {
                              type: "datetime",
                              format: "yyyy-MM-dd HH:mm",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: _vm.$t("pc_biz_ote_lbl_starttime"),
                            },
                            model: {
                              value: _vm.entryTime[0],
                              callback: function ($$v) {
                                _vm.$set(_vm.entryTime, 0, $$v)
                              },
                              expression: "entryTime[0]",
                            },
                          }),
                          _c("span", { staticClass: "ml10 mr10" }, [
                            _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_to"))),
                          ]),
                          _c("yxt-date-picker", {
                            staticClass: "w-200",
                            attrs: {
                              type: "datetime",
                              format: "yyyy-MM-dd HH:mm",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: _vm.$t("pc_biz_ote_lbl_endtime"),
                            },
                            model: {
                              value: _vm.entryTime[1],
                              callback: function ($$v) {
                                _vm.$set(_vm.entryTime, 1, $$v)
                              },
                              expression: "entryTime[1]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "mt-32px",
                      attrs: { prop: "forceSubmitTime" },
                    },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          model: {
                            value: _vm.isForceSubmitCtrl,
                            callback: function ($$v) {
                              _vm.isForceSubmitCtrl = $$v
                            },
                            expression: "isForceSubmitCtrl",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_submittime")))]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isForceSubmitCtrl,
                              expression: "isForceSubmitCtrl",
                            },
                          ],
                          staticClass: "yxtbiz-exam-arrange-makeup__time",
                        },
                        [
                          _c("yxt-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              placeholder: _vm.$t("pc_biz_ote_tip_submittime"),
                              format: "yyyy-MM-dd HH:mm",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.ruleForm.forceSubmitTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "forceSubmitTime", $$v)
                              },
                              expression: "ruleForm.forceSubmitTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "color-gray-9 mt-16px",
                      attrs: { prop: "usedTimesLenMin" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-mid" },
                        [
                          _c(
                            "yxt-checkbox",
                            {
                              model: {
                                value: _vm.isUsedTimesCtrl,
                                callback: function ($$v) {
                                  _vm.isUsedTimesCtrl = $$v
                                },
                                expression: "isUsedTimesCtrl",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("pc_biz_ote_lbl_examtimelength"))
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isUsedTimesCtrl,
                                  expression: "isUsedTimesCtrl",
                                },
                              ],
                            },
                            [
                              _c("yxt-input-number", {
                                staticClass: "w-98 ml8",
                                attrs: { precision: 0, min: 1, max: 999 },
                                on: {
                                  blur: function ($event) {
                                    return _vm.numberInputMinus(
                                      _vm.ruleForm,
                                      "usedTimesLenMin"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.usedTimesLenMin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "usedTimesLenMin",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.usedTimesLenMin",
                                },
                              }),
                              _c("span", { staticClass: "ml8" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("pc_biz_ote_lbl_minites"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "color-gray-9 mt-16px",
                      attrs: { prop: "shortUsedTimesLenMin" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-mid" },
                        [
                          _c(
                            "yxt-checkbox",
                            {
                              model: {
                                value: _vm.isShortUsedTimesCtrl,
                                callback: function ($$v) {
                                  _vm.isShortUsedTimesCtrl = $$v
                                },
                                expression: "isShortUsedTimesCtrl",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("pc_ulcd_ote_lbl_shorttime"))
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isShortUsedTimesCtrl,
                                  expression: "isShortUsedTimesCtrl",
                                },
                              ],
                            },
                            [
                              _c("yxt-input-number", {
                                staticClass: "w-98 ml8",
                                attrs: { precision: 0, min: 1, max: 999 },
                                on: {
                                  blur: function ($event) {
                                    return _vm.numberInputMinus(
                                      _vm.ruleForm,
                                      "shortUsedTimesLenMin"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.ruleForm.shortUsedTimesLenMin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "shortUsedTimesLenMin",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.shortUsedTimesLenMin",
                                },
                              }),
                              _c("span", { staticClass: "ml8" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("pc_biz_ote_lbl_minites"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.multiSetting
                    ? _c(
                        "yxt-form-item",
                        {
                          staticClass: "color-gray-9 mt-16px",
                          attrs: { prop: "repeated" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c(
                                "yxt-checkbox",
                                {
                                  model: {
                                    value: _vm.isRepeated,
                                    callback: function ($$v) {
                                      _vm.isRepeated = $$v
                                    },
                                    expression: "isRepeated",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("pc_biz_ote_lbl_multimakeup"))
                                  ),
                                ]
                              ),
                              _vm.isRepeated
                                ? _c(
                                    "div",
                                    { staticClass: "bg-gray-1 ph20 mt8" },
                                    [
                                      _c(
                                        "yxt-radio-group",
                                        {
                                          model: {
                                            value: _vm.repeatedSetting,
                                            callback: function ($$v) {
                                              _vm.repeatedSetting = $$v
                                            },
                                            expression: "repeatedSetting",
                                          },
                                        },
                                        [
                                          _c(
                                            "yxt-radio",
                                            { attrs: { label: 1 } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "pc_biz_ote_lbl_exam_times_nolimit" /* 不限次 */
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "yxt-radio",
                                            { attrs: { label: 2 } },
                                            [
                                              _c(
                                                "yxtbiz-language-slot",
                                                {
                                                  attrs: {
                                                    inline: "",
                                                    "lang-key":
                                                      "pc_biz_ote_lbl_exam_times_limit_count",
                                                  },
                                                },
                                                [
                                                  _c("yxt-input-number", {
                                                    staticClass: "ml8 w-82",
                                                    attrs: {
                                                      slot: "0",
                                                      precision: 0,
                                                      "controls-position":
                                                        "right",
                                                      min: 2,
                                                      max: 99,
                                                      disabled:
                                                        _vm.repeatedSetting !==
                                                        2,
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        return _vm.numberInputHandle(
                                                          _vm.ruleForm,
                                                          "repeatTimes",
                                                          2
                                                        )
                                                      },
                                                    },
                                                    slot: "0",
                                                    model: {
                                                      value:
                                                        _vm.ruleForm
                                                          .repeatTimes,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ruleForm,
                                                          "repeatTimes",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ruleForm.repeatTimes",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "color-gray-6" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pc_biz_ote_msg_exam_times_tips"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_examdesc"),
                        prop: "description",
                      },
                    },
                    [
                      _c("yxt-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "textarea",
                          placeholder: _vm.$t("pc_biz_ote_tip_examdescinput"),
                          rows: "5",
                          autocomplete: "off",
                          maxlength: 10000,
                        },
                        model: {
                          value: _vm.ruleForm.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "description", $$v)
                          },
                          expression: "ruleForm.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "fixedFooterStyle width640" }, [
        _c(
          "div",
          { staticClass: "text-right ph24" },
          [
            _c(
              "yxt-button",
              {
                attrs: { plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.cancle()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
            ),
            _c(
              "yxt-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
            ),
          ],
          1
        ),
      ]),
      _c(
        "yxt-drawer",
        {
          ref: "selector",
          attrs: {
            title: _vm.$t("pc_biz_ote_btn_selectpaper"),
            size: "960px",
            "append-to-body": "",
            "modal-append-to-body": "",
            visible: _vm.selectExamDrawerData.isShowSelectExamDrawer,
            "destroy-on-close": true,
            direction: "rtl",
            "before-close": function () {
              _vm.saveExamSelect(true)
            },
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(
                _vm.selectExamDrawerData,
                "isShowSelectExamDrawer",
                $event
              )
            },
          },
        },
        [
          _c("yxtbiz-exam-selector", {
            attrs: {
              "function-code": _vm.functionCode,
              "data-permission-code": _vm.dataPermissionCodes.selectExam,
              type: 0,
            },
            on: {
              select: function ($event) {
                return _vm.saveExamSelect()
              },
            },
            model: {
              value: _vm.selectExamDrawerData.exam,
              callback: function ($$v) {
                _vm.$set(_vm.selectExamDrawerData, "exam", $$v)
              },
              expression: "selectExamDrawerData.exam",
            },
          }),
        ],
        1
      ),
      _c("participants-drawer", {
        ref: "participantsDrawer",
        attrs: {
          "group-select": _vm.groupSelect,
          "batch-id": _vm.batchId,
          "project-id": _vm.projectId,
          "task-id": _vm.taskId,
        },
        on: { close: _vm.getUserList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }